const conseillers = [
    {
        id: 1,
        name: "Jean-François",
        picture: 'https://scontent-frt3-2.xx.fbcdn.net/v/t31.0-8/28423768_10213611233147237_3439682089754223558_o.jpg?_nc_cat=0&oh=63f456cc3b88b822b827ba685c1a0efe&oe=5BDBDF34',
        cabinetId: 56,
        company: "cabinet1",
        email: 'jf@test.fr',
        phone: '412-456-2318',
        address: '28 rue des fromagers',
        city: 'Paris',
        country: 'France',
        advisor: 'JP le conseiller',
        role: 'client',
        available: true
    },
    {
        id: 2,
        name: "Jean-François2",
        picture: 'https://scontent-frt3-2.xx.fbcdn.net/v/t31.0-8/28423768_10213611233147237_3439682089754223558_o.jpg?_nc_cat=0&oh=63f456cc3b88b822b827ba685c1a0efe&oe=5BDBDF34',
        cabinetId: 56,
        company: "cabinet3",
        email: 'jf@test.fr',
        phone: '412-456-2318',
        address: '28 rue des fromagers',
        city: 'Paris',
        country: 'France',
        role: 'Admin',
        available: true
    },
    {
        id: 3,
        name: "Jean-François3",
        picture: 'https://scontent-frt3-2.xx.fbcdn.net/v/t31.0-8/28423768_10213611233147237_3439682089754223558_o.jpg?_nc_cat=0&oh=63f456cc3b88b822b827ba685c1a0efe&oe=5BDBDF34',
        cabinetId: 56,
        company: "cabinet1",
        email: 'jf@test.fr',
        phone: '412-456-2318',
        address: '28 rue des fromagers',
        city: 'Paris',
        country: 'France',
        role: 'CGP',
        available: false
    },
    {
        id: 4,
        name: "Jean-François4",
        picture: 'https://scontent-frt3-2.xx.fbcdn.net/v/t31.0-8/28423768_10213611233147237_3439682089754223558_o.jpg?_nc_cat=0&oh=63f456cc3b88b822b827ba685c1a0efe&oe=5BDBDF34',
        cabinetId: 56,
        company: "cabinet3",
        email: 'jf@test.fr',
        phone: '412-456-2318',
        address: '28 rue des fromagers',
        city: 'Paris',
        country: 'France',
        advisor: 'Robert le conseiller',
        role: 'client',
        available: true
    },
    {
        id: 5,
        name: "Jean-François5",
        picture: 'https://scontent-frt3-2.xx.fbcdn.net/v/t31.0-8/28423768_10213611233147237_3439682089754223558_o.jpg?_nc_cat=0&oh=63f456cc3b88b822b827ba685c1a0efe&oe=5BDBDF34',
        cabinetId: 56,
        company: "cabinet2",
        email: 'jf@test.fr',
        phone: '412-456-2318',
        address: '28 rue des fromagers',
        city: 'Paris',
        country: 'France',
        role: 'CGP',
        available: false
    },
    {
        id: 6,
        name: "Jean-François6",
        picture: 'https://scontent-frt3-2.xx.fbcdn.net/v/t31.0-8/28423768_10213611233147237_3439682089754223558_o.jpg?_nc_cat=0&oh=63f456cc3b88b822b827ba685c1a0efe&oe=5BDBDF34',
        cabinetId: 56,
        company: "cabinet2",
        email: 'jf@test.fr',
        phone: '412-456-2318',
        address: '28 rue des fromagers',
        city: 'Paris',
        country: 'France',
        role: 'Admin',
        available: true
    },
]

export default conseillers;


// WEBPACK FOOTER //
// ./src/fixtures/users.js